// External deps
import { useState, useEffect, useContext, useRef } from 'react';
import { useFormikContext } from 'formik';

// Internal deps
import LoaderContext from '../../../context/LoaderProvider';
import useLoadServices from '../../../hooks/useLoadServices';
import {
  getBudgetService,
  getBusinessUnitsLocations,
  getBusinessUnitsPozos,
  getEventsWell,
  getEventsWellTeam,
  getImputationDefault,
  getImputationsDetails,
  getLocationsDetail,
  getUbicationsByUnitBussines,
  getWellsByUnitBussines,
  getBusinessUnits,
  getUbicationsOyM,
  getOperationsOyM,
  getInstallationsOyM,
  getImputationObjectOyM,
  getClassifications,
  getTypeOfEvents,
  getActiveOptions
} from '../../../services/yclickMaster';
import { imputationTypeEnum, ubicationTypeEnum } from '../../../utils/dataStatus';
import { stepEnum } from '../Constants';
import useToast from '../../../hooks/useToast';
import { mapperAccountAssignmentObject, mapperImputationDefault } from '../../../utils/mapper';

const getIdLocationUbication = (values) => (values.ubication?.ubicationType?.id !== 1 ? 0 : 1);

const useUbicationForm = (
  isAutocomplete,
  autocompletWells,
  refreshWells,
  isDraft,
  createSDS,
  dontFetchDetailWell
) => {
  const { values, errors, setFieldValue, setFieldTouched } = useFormikContext();

  const { setLoader } = useContext(LoaderContext);
  const [aditionalTeams, setAditionalTeams] = useState(false);
  const [cantWells, setCantWells] = useState();
  const [equipment, setEquipment] = useState([]);
  const [event, setEvent] = useState([]);
  const [typeOfEventOptions, setTypeOfEventOptions] = useState([]);
  const [eventState, setEventState] = useState(null);
  const [optionUnits, setOptionUnits] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [teamState, setTeamState] = useState(null);
  const [ubicationState, setUbicationState] = useState(null);
  const [uunnState, setUunnState] = useState(null);
  const [warning, setWarning] = useState(false);
  const [activeOptions, setActiveOptions] = useState([]);

  const { setNewToast } = useToast();

  const idLocationUbication = getIdLocationUbication(values);
  const containerRef = useRef();
  const step = values?.currentStep;

  const { ubicationTypeSelect, businessUnitSelect } = useLoadServices({
    createSDS
  });

  const setStep = (newStep) => setFieldValue('currentStep', newStep);

  const mapWellsWithDetails = (wells, details) =>
    wells
      .filter((well) => well.tipoImputacion?.id && well.objetoImputacion?.id)
      .map((w) => {
        if (details.some((det) => det.pozoId === w.pozo.id)) {
          const detail = details.find((det) => det.pozoId === w.pozo.id);

          return {
            ...w,
            detalleObjeto: detail
          };
        }

        return w;
      });

  const mapWellsWithoutOI = (wells) => {
    const newWellsWithoutOI = wells.filter(
      (well) => !well.tipoImputacion?.id && !well.objetoImputacion?.id
    );

    return newWellsWithoutOI.length
      ? mapperAccountAssignmentObject({ wells: newWellsWithoutOI, budget: [], event: null })
      : [];
  };

  const createDefaultObject = (obj) => ({
    ...obj,
    id: obj?.id,
    nombre: obj?.nombre,
    value: obj?.id,
    label: obj?.nombre
  });

  const setDetails = (details, wells, budget) => {
    // Map the well with its detailed data about the well
    const newWells = mapWellsWithDetails(wells, details);

    const mappedWells = mapperAccountAssignmentObject({
      wells: newWells,
      budget,
      event: values?.ubication?.event
    });

    // Previously filtered by TI and OI because they can
    // apparently come as null
    const mappedWellsWithoutOI = mapWellsWithoutOI(wells);

    const finalWells = [...mappedWells, ...mappedWellsWithoutOI];

    // wellsCopy: backup in case of exiting during OI editing

    setFieldValue('imputationObject', {
      wells: finalWells,
      wellsCopy: finalWells
    });
  };

  const fetchDataUbication = async (value, uunnId) => {
    if (value.length < 3) return [];

    try {
      if (values.ubication?.ubicationType?.id === ubicationTypeEnum.pozo) {
        const ubicationPozo = await getWellsByUnitBussines(
          value,
          uunnId ? [uunnId] : optionUnits.map((unit) => unit.id)
        );

        return ubicationPozo;
      }

      if (values.ubication?.ubicationType?.id === ubicationTypeEnum.locacion) {
        const ubicationLocacion = await getUbicationsByUnitBussines(
          value,
          uunnId ? [uunnId] : optionUnits.map((unit) => unit.id)
        );

        return ubicationLocacion;
      }

      // NOSONAR: TODO: filtrar por operaciones disponibles
      const ubicationOyM = await getUbicationsOyM({
        tipoUbicacionId: values.ubication.ubicationType?.id,
        nombre: value,
        activoId: values.ubication.active?.id,
        operacionId: values.ubication.uunn?.id,
        instalacionId: values.ubication.installation?.id,
        clasificacionId: values.ubication.classification?.id,
        todas: false
      });

      return ubicationOyM;
    } catch (error) {
      return setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const fetchDataActive = async (value) => {
    if (value.length < 3) return [];

    const body = {
      tipoUbicacionId: values.ubication?.ubicationType?.id,
      instalacionId: values.ubication?.installation?.id || null,
      ubicacionId: values.ubication?.ubication?.id || null,
      operacionId: values.ubication?.uunn?.id || null,
      clasificacionId: values.ubication?.classification?.id || null,
      nombre: value
    };

    try {
      const activeOptionsResponse = await getActiveOptions(body);

      return activeOptionsResponse;
    } catch (error) {
      return setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };
  const getClassificationByUbicationId = async (ubicationId) => {
    try {
      const classifications = await getClassifications({
        body: {
          nombre: '',
          tipoUbicacionId: values.ubication.ubicationType?.id,
          operacionId: values.ubication.uunn?.id,
          ubicacionId: ubicationId,
          activoId: values.ubication.active?.id
        }
      });

      setUbicationState(classifications);

      if (classifications.length === 1) {
        setFieldValue('ubication.classification', createDefaultObject(classifications[0]));
      }

      return classifications;
    } catch (error) {
      return setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const fetchDataClassification = async (value) => {
    if (value.length < 3) return [];
    try {
      const classifications = await getClassifications({
        body: {
          nombre: value,
          tipoUbicacionId: values.ubication.ubicationType?.id,
          operacionId: values.ubication.uunn?.id,
          ubicacionId: values.ubication.ubication?.id,
          activoId: values.ubication.active?.id
        }
      });

      return classifications;
    } catch (error) {
      return setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const getOperationByClassificationId = async (clasificacionId) => {
    try {
      const operations = await getOperationsOyM({
        tipoUbicacionId: values.ubication.ubicationType?.id,
        clasificacionId
      });

      setOptionUnits(operations);
      if (operations.length === 1) {
        setFieldValue('ubication.uunn', createDefaultObject(operations[0]));
        setUunnState(operations[0]);
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const fetchDataInstallation = async (value) => {
    if (value.length < 3) return [];

    try {
      const installations = await getInstallationsOyM({
        body: {
          nombre: value,
          tipoUbicacionId: values.ubication.ubicationType?.id,
          operacionId: values.ubication.uunn?.id,
          activoId: values.ubication.active?.id,
          ubicacionId: values.ubication.ubication?.id
        }
      });

      return installations;
    } catch (error) {
      return setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const getUnitsBusinessOfUser = async () => {
    try {
      if (!values.isOyM) {
        const businessUnit = await getBusinessUnits();

        setOptionUnits(businessUnit);

        return;
      }

      const operationsOyM = await getOperationsOyM({
        tipoUbicacionId: values.ubication.ubicationType?.id
      });

      setOptionUnits(operationsOyM);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
      setOptionUnits([]);
    }
  };

  const handleSingleBusinessUnit = (businessUnits) => {
    setOptionUnits(businessUnits);
    if (businessUnits.length === 1) {
      setUunnState(businessUnits[0]);
    }
  };

  const getUnitsBusiness = async (valId) => {
    try {
      if (valId === ubicationTypeEnum.locacion) {
        const businessUnitLocation = await getBusinessUnitsLocations();

        handleSingleBusinessUnit(businessUnitLocation);

        return;
      }

      if (valId === ubicationTypeEnum.pozo) {
        const businessUnitPozo = await getBusinessUnitsPozos();

        handleSingleBusinessUnit(businessUnitPozo);

        return;
      }

      if (valId > 2) {
        const operationsOyM = await getOperationsOyM({
          tipoUbicacionId: valId
        });

        handleSingleBusinessUnit(operationsOyM);
      }
    } catch {
      setOptionUnits([]);
    }
  };

  const handleEmptyWellsDetails = () => {
    setFieldValue('imputationObject', {
      wells: [],
      wellsCopy: []
    });
  };

  const fetchBudgetDetails = async (wellsDetails) =>
    // eslint-disable-next-line no-return-await
    await Promise.all(
      wellsDetails.map((pozo) =>
        pozo.tipoImputacion.id === imputationTypeEnum.PEP
          ? getBudgetService(pozo.objetoImputacion.id)
          : null
      )
    ).catch(() => []);

  const mapWellsDetails = (wellsDetails) =>
    wellsDetails.map((imp) => ({
      ...imp,
      objetoImputacion: {
        ...imp.objetoImputacion,
        nombre: imp.objetoImputacion?.codigo
      }
    }));

  const mapAndFilterWellsDetails = (wellsDetails) =>
    wellsDetails
      .map((well) => ({
        pozoId: well.pozo?.id,
        tipoId: well.tipoImputacion?.id,
        objetoId: well.objetoImputacion?.id
      }))
      .filter((obj) => obj.tipoId && obj.objetoId);

  const createImputationType = (imputationTypeAndObject) => {
    if (imputationTypeAndObject.length) {
      return {
        ...imputationTypeAndObject[0]?.tipoImputacion,
        label: imputationTypeAndObject[0]?.tipoImputacion?.nombre,
        value: imputationTypeAndObject[0]?.tipoImputacion?.id
      };
    }

    return null;
  };

  const createImputationObject = (imputationTypeAndObject) => {
    if (imputationTypeAndObject.length) {
      return {
        ...imputationTypeAndObject[0]?.objetoImputacion,
        label:
          imputationTypeAndObject[0]?.objetoImputacion?.codigo &&
          imputationTypeAndObject[0]?.objetoImputacion?.descripcion
            ? `${imputationTypeAndObject[0]?.objetoImputacion?.codigo} | ${imputationTypeAndObject[0]?.objetoImputacion?.descripcion}`
            : null,
        value: imputationTypeAndObject[0]?.objetoImputacion?.id
      };
    }

    return null;
  };

  const locationsHelper = async () => {
    if (values?.ubication?.ubicationType?.id === ubicationTypeEnum.locacion) {
      setLoader(true);
      const idLocation = values?.ubication?.ubication?.id || ubicationState?.id;
      const wells = await getLocationsDetail(idLocation);

      setCantWells(wells.pozosLocacion);
      if (!wells.detalles.length) {
        handleEmptyWellsDetails();
      } else {
        const resBudget = await fetchBudgetDetails(wells.detalles);

        const newWells = mapWellsDetails(wells.detalles);

        setFieldValue('ubication.event', {
          ...wells.detalles[0].evento,
          id: wells.detalles[0].evento.id,
          sigla: wells.detalles[0].evento.sigla
        });
        setFieldValue('ubication.team', wells.detalles[0].equipo);

        const bodyImpDetail = mapAndFilterWellsDetails(wells.detalles);

        const details = await getImputationsDetails(bodyImpDetail);

        setDetails(details, newWells, resBudget);
      }

      setLoader(false);
    }
  };

  const getWellsLocation = async () => {
    try {
      await locationsHelper();
      if (
        values?.ubication?.ubicationType?.id === ubicationTypeEnum.pozo &&
        (values.ubication?.event || eventState) &&
        (values.ubication?.team || teamState)
      ) {
        setLoader(true);
        const imputationDefault = await getImputationDefault([
          {
            eventoPozoId: eventState?.eventoPozoId || values?.ubication?.event?.eventoPozoId
          }
        ]);

        const newImputationDefault = mapWellsDetails(imputationDefault);

        const wells = [
          {
            pozo: values?.ubication?.ubication,
            evento: {
              ...values?.ubication?.event,
              idEventoPozo:
                values.ubication?.event?.eventoPozoId ||
                values?.imputationObject?.wells[0]?.event?.eventoPozoId
            },
            equipo: values?.ubication?.team,
            ...newImputationDefault[0]
          }
        ];

        const bodyImpDetail = mapAndFilterWellsDetails(wells);

        const details = await getImputationsDetails(bodyImpDetail);
        let budget = [];

        // There is only a single well
        if (wells[0].tipoImputacion.id === imputationTypeEnum.PEP) {
          const detailBudget = await getBudgetService(wells[0].objetoImputacion.id);

          budget = [detailBudget];
        }
        setDetails(details, wells, budget);
        setLoader(false);

        return;
      }

      if (values.isOyM && values?.ubication?.ubication?.id) {
        setLoader(true);
        const imputationTypeAndObject = await getImputationObjectOyM([
          values?.ubication?.ubication?.id
        ]);

        const [details] = await getImputationsDetails([
          {
            // Al ser OyM se envia 0 en pozoId
            pozoId: 0,
            tipoId: imputationTypeAndObject[0]?.tipoImputacion?.id,
            objetoId: imputationTypeAndObject[0]?.objetoImputacion?.id
          }
        ]);

        const mappedDetails = mapperImputationDefault(
          details,
          imputationTypeAndObject[0]?.tipoImputacion
        );

        const well = [
          {
            well: values?.ubication?.ubication,
            event: null,
            team: null,
            imputationType: createImputationType(imputationTypeAndObject),
            imputationObject: createImputationObject(imputationTypeAndObject),
            ...mappedDetails
          }
        ];

        setFieldValue('imputationObject.wells', well);
        // for backup in case the user wants to exit after editing the imputationType
        setFieldValue('imputationObject.wellsCopy', well);
        setLoader(false);
      }
    } catch {
      setLoader(false);
    }
  };

  const getEventsIdTeam = async (eventObj, isDraftOrReplicate = false) => {
    try {
      const eventEquipment = await getEventsWellTeam(eventObj?.eventoPozoId, aditionalTeams);

      setEquipment(eventEquipment.opciones);
      if (!isDraftOrReplicate) {
        if (eventEquipment.default) {
          setFieldValue('ubication.team', createDefaultObject(eventEquipment.default));
          setTeamState(createDefaultObject(eventEquipment.default));
        } else {
          setFieldValue('ubication.team', null);
        }
      }
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
      setEquipment([]);
    }
  };

  const getEventIdPozo = async (pozoObj, isDraftOrReplicate = false) => {
    try {
      const eventsPozo = await getEventsWell(pozoObj?.id);

      setEvent(eventsPozo?.opciones || []);

      if (isDraftOrReplicate) {
        if (values?.ubication?.event) {
          getEventsIdTeam(values?.ubication?.event, isDraftOrReplicate);
        } else if (eventsPozo.default) {
          getEventsIdTeam(eventsPozo.default, isDraftOrReplicate);
        }
      }
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
      setEvent([]);
    }
  };

  const checkHasLocation = async (idPozoLocation) => {
    const isLocacion = values.ubication.ubicationType?.id === ubicationTypeEnum.locacion;

    if (!isLocacion || !idPozoLocation) return false;
    const businessUnitsLocation = await getBusinessUnitsLocations(idPozoLocation);

    setOptionUnits(businessUnitsLocation);
    if (businessUnitsLocation.length === 1) {
      setFieldValue('ubication.uunn', createDefaultObject(businessUnitsLocation[0]));
      setUunnState(businessUnitsLocation[0]);
    }

    return true;
  };

  const getUnitsBusinessId = async ({ idPozoLocation, activeId }) => {
    try {
      const hasLocation = await checkHasLocation(idPozoLocation);

      if (hasLocation) return;

      if (values.ubication.ubicationType?.id === ubicationTypeEnum.pozo && idPozoLocation) {
        const businessUnitsPozo = await getBusinessUnitsPozos(idPozoLocation);

        setOptionUnits(businessUnitsPozo);
        if (businessUnitsPozo.length === 1) {
          setFieldValue('ubication.uunn', createDefaultObject(businessUnitsPozo[0]));
          setUunnState(businessUnitsPozo[0]);
        }

        return;
      }

      if (
        (values.ubication.ubicationType?.id === ubicationTypeEnum.ducto ||
          values.ubication.ubicationType?.id === ubicationTypeEnum.energia) &&
        idPozoLocation &&
        !values.ubication?.installation
      ) {
        const installationOyM = await getInstallationsOyM({
          body: {
            nombre: '',
            tipoUbicacionId: values.ubication.ubicationType?.id,
            operacionId: values.ubication?.uunn?.id,
            activoId: values.ubication.active?.id,
            ubicacionId: idPozoLocation
          }
        });

        if (installationOyM.length === 1) {
          setFieldValue('ubication.installation', createDefaultObject(installationOyM[0]));
        }

        return;
      }
      let operationOyM;

      if (activeId) {
        operationOyM = await getOperationsOyM({
          tipoUbicacionId: values.ubication.ubicationType?.id,
          activoId: activeId
        });

        setOptionUnits(operationOyM);
        if (operationOyM.length === 1) {
          setFieldValue('ubication.uunn', createDefaultObject(operationOyM[0]));
          setUunnState(operationOyM[0]);
        }

        return;
      }
      operationOyM = await getOperationsOyM({
        tipoUbicacionId: values.ubication.ubicationType?.id,
        ubicacionId: idPozoLocation
      });

      setOptionUnits(operationOyM);
      if (operationOyM.length === 1) {
        setFieldValue('ubication.uunn', createDefaultObject(operationOyM[0]));
        setUunnState(operationOyM[0]);
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
      setOptionUnits([]);
    }
  };

  const handleActiveOptions = (options) => {
    setActiveOptions(options);
  };
  const getActiveId = async (params) => {
    const tipoUbicacionId = Number(params?.tipoUbicacionId);

    // Validation: if 1 o 2, dont call actives endpoint
    if ([1, 2].includes(tipoUbicacionId)) {
      return;
    }
    const body = { ...params };

    try {
      const activeOptionsById = await getActiveOptions(body);

      if (activeOptionsById.length === 1) {
        setFieldValue('ubication.active', createDefaultObject(activeOptionsById[0]));
      } else {
        handleActiveOptions(activeOptionsById);
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const getOperationByInstallationId = async (instalacionId) => {
    try {
      const operationOyM = await getOperationsOyM({
        tipoUbicacionId: values.ubication.ubicationType?.id,
        instalacionId
      });

      setOptionUnits(operationOyM);
      if (operationOyM.length === 1) {
        setFieldValue('ubication.uunn', createDefaultObject(operationOyM[0]));
        setUunnState(operationOyM[0]);
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const getWellsError = () => {
    if (errors?.imputationObject?.wells && !Array.isArray(errors?.imputationObject?.wells)) {
      return errors?.imputationObject?.wells;
    }
    const hasError = errors?.imputationObject?.wells
      .filter((wellError) => !!wellError)
      .map((wellImputationObject) => ({
        imputationObject: wellImputationObject.imputationObject
      }));

    if (hasError) {
      return hasError[0]?.imputationObject;
    }

    return null;
  };

  const getTypeOfEventsOptions = async (id) => {
    try {
      const typeEvents = await getTypeOfEvents(id);

      setTypeOfEventOptions(
        typeEvents?.map((eventType) => ({
          ...eventType,
          nombreLargo: eventType?.nombre,
          id: eventType?.id,
          nombre: eventType?.sigla,
          value: eventType?.id,
          label: eventType?.sigla
        }))
      );
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const resetField = (fieldValue, fieldName, resetValue) => {
    if (fieldValue) {
      setFieldTouched(fieldName);
    }
    setFieldValue(fieldName, resetValue);
  };

  const getAccordionFieldName = (accordionIndex, accordionField) =>
    `accordions[${accordionIndex}].${accordionField}`;

  const handleSwitchAdditionTeams = () => {
    setAditionalTeams((oldState) => !oldState);
    setFieldValue('ubication.team', null);
  };

  useEffect(() => {
    const isWarningBudget = values?.imputationObject?.wells?.some((item) => item.warningBudget);
    const isWarningState = values?.imputationObject?.wells?.some((item) => item.warningState);

    if (isWarningBudget || isWarningState) {
      setWarning(true);
    } else {
      setWarning(false);
    }
  }, [values]);

  useEffect(() => {
    if (step === stepEnum.ubication) {
      containerRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [step]);

  useEffect(() => {
    // TODO: Hot fix - Validar que no rompa logica poner solo || para refreshWells (GF)
    if ((uunnState && ubicationState && (autocompletWells || isDraft)) || refreshWells) {
      if (!dontFetchDetailWell) getWellsLocation();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    uunnState,
    ubicationState,
    eventState,
    teamState,
    values?.ubication?.ubication,
    values?.ubication?.installation,
    values?.ubication?.uunn,
    refreshWells
  ]);

  useEffect(() => {
    const eventSelected = values?.ubication?.event;

    if (eventSelected?.id) {
      getEventsIdTeam(eventSelected, isDraft || isAutocomplete);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aditionalTeams]);

  // Autocomplete selects when applying a template
  // we do this because when applying a template we do not detect the onChange event on fields
  // so we must load it manually
  // If the location type changes from applying a template
  // useEffect(() => {
  //   if (values?.ubication?.ubicationType?.id && isAutocomplete) {
  //     getUnitsBusiness(values?.ubication?.ubicationType?.id);
  //   }
  // }, [values?.ubication?.ubicationType]);

  useEffect(() => {
    if (values.ubication?.ubication?.id && isAutocomplete) {
      setUbicationState(values?.ubication?.ubication);
      getUnitsBusinessId({ idPozoLocation: values.ubication?.ubication?.id });
      if (values.ubication?.ubicationType?.id === ubicationTypeEnum.pozo) {
        getEventIdPozo(values.ubication?.ubication, isAutocomplete);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.ubication?.ubication]);

  return {
    aditionalTeams,
    cantWells,
    containerRef,
    equipment,
    event,
    eventState,
    fetchDataUbication,
    fetchDataActive,
    getAccordionFieldName,
    getEventIdPozo,
    getEventsIdTeam,
    getUnitsBusiness,
    getUnitsBusinessId,
    getActiveId,
    getWellsError,
    getUnitsBusinessOfUser,
    handleSwitchAdditionTeams,
    idLocationUbication,
    optionUnits,
    resetField,
    setEventState,
    setOptionUnits,
    setShowModal,
    setStep,
    setTeamState,
    setUbicationState,
    setUunnState,
    showModal,
    step,
    teamState,
    businessUnitSelect,
    warning,
    getWellsLocation,
    getOperationByInstallationId,
    getOperationByClassificationId,
    fetchDataInstallation,
    ubicationTypeSelect,
    fetchDataClassification,
    getClassificationByUbicationId,
    getTypeOfEventsOptions,
    typeOfEventOptions,
    activeOptions,
    handleActiveOptions
  };
};

export default useUbicationForm;
